exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PopDialog_style_function_button_area__svzF- {\n  width: 100%;\n  margin-top: 12px;\n  display: inline-flex;\n  justify-content: center; }\n\n.PopDialog_style_listitem__2qn_e {\n  display: inline-flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start; }\n\n.PopDialog_style_popup_content__3jHiN {\n  padding: 24px;\n  overflow: auto; }\n\n.PopDialog_style_text__1tEW8 {\n  font-weight: 300;\n  line-height: 1.7em;\n  font-size: 1.1em; }\n\n.PopDialog_style_margin2__d7hT_ {\n  margin: 0 2px !important;\n  width: auto !important; }\n", ""]);

// exports
exports.locals = {
	"function_button_area": "PopDialog_style_function_button_area__svzF-",
	"listitem": "PopDialog_style_listitem__2qn_e",
	"popup_content": "PopDialog_style_popup_content__3jHiN",
	"text": "PopDialog_style_text__1tEW8",
	"margin2": "PopDialog_style_margin2__d7hT_"
};